import { WebPageJsonLd } from "next-seo";
import { addBaseUrl } from "./addBaseUrl";
import { Routes } from "~/routes";

// // // //

export function getProtocolListPageDescription(): string {
    return `Explore comprehensive insights on RWA Platforms, including market cap, supply metrics, issuance volumes, and more.`;
}

// // // //

/**
 * Renders WebPage SEO metadata for the Protocol List page using the `ArticleJsonLd` component from `next-seo`.
 */
export function ProtocolListSEO() {
    // Get yesterday's date
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const isoYesterday = yesterday.toISOString();

    return (
        <WebPageJsonLd
            id={addBaseUrl(Routes.platforms)}
            description={getProtocolListPageDescription()}
            lastReviewed={isoYesterday}
            reviewedBy={{
                type: "Organization",
                name: "RWA.xyz",
            }}
        />
    );
}
